// extracted by mini-css-extract-plugin
export default {"create-and-filter":"CreateAndFilter_create-and-filter__D2nJa"};